import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
} from '@ionic/react';
import {
  Box,
  Stack,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import PageWithBackButton from 'components/generic/PageWithBackButton';
import './GoalsCreate.css';
import appStrings from 'common/app_strings';
import { goalTypeButtons } from './utils';

const { goals: { goalsType: STRINGS } } = appStrings;

const GoalsType = ({ onComplete, onBack }) => {
  const handleGoalTypeSelect = (goalType) => {
    onComplete({ type: goalType });
  };

  return (
    <PageWithBackButton backButtonText="New Goal" onBack={onBack}>
      <IonContent fullscreen>
        <Box mx={3}>
          <Typography
            variant="h4"
            fontSize={20}
            fontWeight={700}
            sx={{ textAlign: 'center', mt: 3.5, mb: 4.5 }}
          >
            {STRINGS.title}
          </Typography>
          <Stack spacing={2} mb={5}>
            {goalTypeButtons?.map((goalType) => (
              <button
                key={goalType?.key}
                type="button"
                className={clsx('goals-type-button', goalType?.classname)}
                style={{ backgroundColor: goalType?.bgColor, border: '1px solid #000' }}
                onClick={() => handleGoalTypeSelect(goalType?.key)}
              >
                <img
                  src={goalType?.icon}
                  className="goals-type-button-icon"
                  alt={`${goalType?.key} goal icon`}
                />
                <Typography
                  variant="h4"
                  fontWeight={700}
                  color="#fff"
                  fontSize={24}
                  width="100%"
                >
                  {goalType?.title}
                </Typography>
              </button>
            ))}
          </Stack>
        </Box>
      </IonContent>
    </PageWithBackButton>
  );
};

GoalsType.propTypes = {
  onComplete: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default GoalsType;
